import api from "../apiConfig";

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    const p = paramsFactory(data);
    return api.get(`/api/v1/ticket-quality?${p}`);
  },
  statuses() {
    return api.get(`/api/v1/ticket-quality/statuses`);
  },
  showById(id) {
    return api.get(`/api/v1/ticket-quality/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/ticket-quality`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  reply(data, config = {}) {
    return api.post(`/api/v1/ticket-quality/reply`, data, config);
  },
   updateStatus(id, status_id) {
    return api.put(`/api/v1/ticket-quality/update-status/${id}`, { status_id });
  },
  updateResponsible(id, data) {
    return api.put(`/api/v1/ticket-quality/update-responsible/${id}`, data);
  },
};
